module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/list-style-square/list-style-square.component.scss
// module id = ./src/app/features/typography/list-style-square/list-style-square.component.scss
// module chunks = main